// ----------------------------------------------------------------------
// <copyright file="Izenda.LineChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {

  module.exports = function(Highcharts) {

    var BASE_CHART = 'line';
    var IZENDA_CHART_NAME = 'izendaLine';
    var seriesTypes = Highcharts.seriesTypes;
    var defaultOptions = Highcharts.getOptions();
    var extend = Highcharts.extend;
    var extendClass = Highcharts.extendClass;


    /**
     * Extend the default options with LINE options
     */
    defaultOptions.plotOptions[IZENDA_CHART_NAME] = Highcharts.merge(defaultOptions.plotOptions[BASE_CHART], {});

    // Define izendaLine series type
    seriesTypes[IZENDA_CHART_NAME] = extendClass(seriesTypes[BASE_CHART], {
      type: IZENDA_CHART_NAME,
      izendaOptions: {
        spline: false
      },

      /**
       * Override the init method to use line or spline chart type
       */
      init: function(chart, data) {

        var izendaOptions = chart.options.izendaOptions || {};

        if (izendaOptions.spline) {
          // extend spline chart type
          extend(this, new seriesTypes.spline);
          return seriesTypes.spline.prototype.init.apply(this, arguments);
        }

        return seriesTypes[BASE_CHART].prototype.init.apply(this, arguments);
      }
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.LineChart.js